import { FormLabel, Grid, TextField } from "@mui/material";


export const ViewAndEditEntity = ({
  
    handleInputChange,
    index,
    row,
    viewMode,
    validationStatus,
}) => {
    //inline style
    const InlineStyle = {
        EntityDivison: {
            width: "230px", height: "32", padding: "0px"
        },
    }
    return (
      <form>
        <Grid container justifyContent={"space-between"}>
          <Grid
            item
            xs={3}
            display={"flex"}
            flexDirection={"column"}
            gap={"5px"}
            mt={"20px"}
          >
            <FormLabel>AgeDebt Category</FormLabel>
            <TextField
              value={row.aged_debt_category}
              onChange={(e) =>
                handleInputChange(index, "aged_debt_category", e.target.value)
              }
              sx={InlineStyle.EntityDivison}
              size="small"
              placeholder="Enter Details Here"
              disabled={viewMode}
            />
            <br />
            {validationStatus[index]?.aged_debt_category && (
              <span style={{ color: "red" }}>
                {validationStatus[index]?.aged_debt_category}
              </span>
            )}
          </Grid>
      
        </Grid>
      </form>
    );
}